import { render, staticRenderFns } from "./MainCardSlider.vue?vue&type=template&id=0b2be48c&"
import script from "./MainCardSlider.vue?vue&type=script&lang=js&"
export * from "./MainCardSlider.vue?vue&type=script&lang=js&"
import style0 from "./MainCardSlider.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports